export default __webpack_public_path__ + "static/media/330_dummy2016-personaltrainer01-de.81aa9ca3.png";